export enum FastTagState {
  ACTIVATED = "activated",
  DEACTIVATED = "deactivated",
  INVALID = "invalid",
}
